import { Link } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Contact";
import { ArrowRight } from "lucide-react";
import { useAuthDialog } from "@/lib/auth-dialog-context";

const RELATED = [
  { label: "LabelDesk", to: "/labeldesk" },
  { label: "Price Manager", to: "/price-manager" },
  { label: "Price Reducer", to: "/price-reducer" },
  { label: "Dashboard", to: "/dashboard" },
];

export const FeaturePageLayout = ({ children, currentPath }) => {
  const { openAuth } = useAuthDialog();

  const others = RELATED.filter((r) => r.to !== currentPath);

  return (
    <div className="font-body text-slate-900 antialiased">
      <Navbar />

      <main className="pt-24 sm:pt-28">
        {children}

        {/* Internal links to other features */}
        <section className="py-16 bg-slate-50 border-t border-slate-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-xs font-bold uppercase tracking-widest text-slate-400 mb-6">
              More EasyLister Tools
            </p>
            <div className="flex flex-wrap gap-3">
              {others.map((r) => (
                <Link
                  key={r.to}
                  to={r.to}
                  className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-purple-200 text-sm font-semibold text-purple-700 hover:bg-purple-50 transition-colors"
                >
                  {r.label} <ArrowRight className="w-3.5 h-3.5" />
                </Link>
              ))}
              <Link
                to="/"
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-slate-200 text-sm font-semibold text-slate-600 hover:bg-white transition-colors"
              >
                ← Back to homepage
              </Link>
            </div>
          </div>
        </section>

        {/* Global CTA */}
        <section className="py-16 bg-gradient-to-br from-purple-600 to-violet-700">
          <div className="max-w-3xl mx-auto px-4 text-center">
            <h2 className="font-heading text-2xl sm:text-3xl font-extrabold text-white">
              Start free — no card needed
            </h2>
            <p className="mt-3 text-purple-100 text-base leading-relaxed">
              3-day free trial includes AI listings, price management, label splitting, and more.
            </p>
            <button
              onClick={() => openAuth("signup")}
              className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 bg-white text-purple-700 font-bold rounded-full shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] transition-all text-sm"
            >
              Get Started Free <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};
